import * as React from 'react';

import { IOfferSchema, ISpecialProjectItemSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import { Link } from '../../../common/components/link';
import { MapTab, TMapTab } from '../../../store/map_tabs';
import { ISpecialPromoInfo, TSpecialPromoInfoState } from '../../../store/special_promo_info';
import { getOfferType, isCommercial } from '../../../utils/offer_type';
import { trackSpecialProjectClick, trackTabMapClick, trackTabPanoramaClick, trackTabSimilarClick } from '../tracking';

import * as styles from './index.css';

const SPECIAL_PROJECTS: { [key: string]: { icon?: string; text: string } } = {
  pik: {
    icon: require('./assets/icon_pik.svg'),
    text: 'Показать ЖК от Группы ПИК',
  },
};

export interface IOfferMapTabsProps {
  offer: IOfferSchema;
  activeTab: TMapTab;
  changeTab(tab: TMapTab): void;
  specialProject: ISpecialProjectItemSchema | null;
  specialPromoInfo: TSpecialPromoInfoState;
  subdomain: string;
}

export class OfferMapTabs extends React.Component<IOfferMapTabsProps, {}> {
  public render() {
    const { specialProject, specialPromoInfo } = this.props;

    const offerType = getOfferType(this.props.offer);
    const isCommercialCard = isCommercial(offerType);
    const specialProjectData = specialProject && SPECIAL_PROJECTS[specialProject.id];

    return (
      <div className={styles['container']}>
        <ul className={styles['tabs']}>
          {this.renderSimilarTab()}
          {this.renderInfrastructureTab()}
          {this.renderPanoramaTab()}
        </ul>
        {!isCommercialCard && specialProject && specialProjectData && (
          <div className={styles['special']}>
            <Link
              href={specialProject.link}
              rel="nofollow noopener"
              onClick={() => trackSpecialProjectClick(specialProject.id)}
            >
              <img src={specialProjectData.icon} alt="" />
              {specialProjectData.text}
            </Link>
          </div>
        )}
        {!isCommercialCard && !specialProjectData && specialPromoInfo && (
          <div className={styles['special-promo']}>
            <Link href={this.getSpecialPromoLink(specialPromoInfo)} rel="nofollow noopener">
              <img src={specialPromoInfo.logoSmallUrl} />
              {specialPromoInfo.textShowOffers}
            </Link>
          </div>
        )}
      </div>
    );
  }

  private renderInfrastructureTab() {
    return (
      <li
        {...mergeStyles([
          styles['tab'],
          styles['onmap'],
          styles['new'],
          this.props.activeTab === MapTab.default && styles['active'],
        ])}
        onClick={() => {
          this.handleClickOnTab(MapTab.default);
          trackTabMapClick();
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
          {/* tslint:disable-next-line:max-line-length */}
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M15.111 0H.89v1.75H15.11V0zM16 8.75V7l-.889-4.375H.89L0 7v1.75h.889V14h8.889V8.75h3.555V14h1.778V8.75H16zm-8 3.5H2.667v-3.5H8v3.5z"
          />
        </svg>
        Инфраструктура
      </li>
    );
  }

  private renderPanoramaTab() {
    return (
      <li
        {...mergeStyles([
          styles['tab'],
          styles['panorama'],
          this.props.activeTab === MapTab.panorama && styles['active'],
        ])}
        onClick={() => {
          this.handleClickOnTab(MapTab.panorama);
          trackTabPanoramaClick();
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.27 15.41" width="24" height="16">
          {/* tslint:disable-next-line:max-line-length */}
          <path
            fill="currentColor"
            d="M15.94 8.93h1.76c.083.01.167.01.25 0 .638-.19 1.07-.785 1.05-1.45v-6c.013-.11.013-.22 0-.33C18.878.5 18.32.022 17.66 0H16c-.288-.005-.57.086-.8.26-.374.283-.587.73-.57 1.2v6c-.01.247.046.49.16.71.212.448.655.74 1.15.76zm1.6-7.49v6.04c-.482.045-.968.045-1.45 0v-6l-.02-.04h1.47zm-4.75 11.03l-1-.86-1.58-1.43c-.066-.044-.136-.08-.21-.11v1.67h-.54c-.69-.034-1.378-.108-2.06-.22h-.25c-.35-.06-.72-.11-1-.17s-.56-.15-.84-.21c-.61-.145-1.21-.34-1.79-.58-.43-.167-.84-.375-1.23-.62-.412-.24-.773-.56-1.06-.94-.19-.246-.303-.54-.33-.85-.022-.448.14-.885.45-1.21.475-.52 1.06-.93 1.71-1.2l.547-.26c-.016-.073-.06-.09-.117-.09l-.31.13c-.644.254-1.252.59-1.81 1-.492.358-.893.828-1.17 1.37-.2.416-.27.883-.2 1.34.02.056.047.11.08.16.03.065.057.132.08.2.056.238.18.454.36.62.045.046.085.096.12.15.052.083.108.164.17.24.595.594 1.297 1.07 2.07 1.4.39.2.89.39 1.18.5s.47.17.88.29.88.23 1.23.31c.35.08.65.15 1.06.22.41.07.77.1 1.25.13.49.078.984.12 1.48.12h.1c.004.077.004.153 0 .23v1.55c.073-.034.144-.074.21-.12l.54-.49 1.49-1.34.58-.53c.026-.016.048-.037.063-.064.05-.086.022-.196-.063-.246l-.09-.09zm1.22-7.22c.008-.226-.033-.45-.12-.66-.218-.538-.75-.882-1.33-.86h-1.17l.75-1.82c.24-.6.51-1.19.74-1.83-.066-.037-.136-.064-.21-.08H11.5c-.106.007-.197.078-.23.18l-.77 1.88c-.19.46-.37.92-.56 1.38-.223.51-.34 1.062-.34 1.62v2.29c.003.22.04.44.11.65.19.512.656.87 1.2.92h1.8c.214-.007.42-.073.6-.19.45-.265.72-.757.7-1.28v-2.2zm-1.49 2.23c-.49.044-.98.044-1.47 0V5.2h1.47v2.28z"
          />
          {/* tslint:disable-next-line:max-line-length */}
          <path
            fill="currentColor"
            d="M4.7 2.24h1.22c.102-.068.157-.188.14-.31v-.37h1.45c.054.76.054 1.52 0 2.28H6.39c-.114-.02-.23.03-.29.13-.054.418-.054.842 0 1.26.09.008.18.008.27 0h1.16V7.5H6.06c-.002-.017-.002-.033 0-.05V7.1c.007-.033.008-.067.002-.1-.026-.14-.16-.235-.302-.21h-.84c-.025-.004-.05-.003-.076 0-.13.025-.217.15-.194.28v.74c.093.65.626 1.145 1.28 1.19h1.59c.222-.007.44-.06.64-.16.496-.222.822-.707.84-1.25V5.28c-.014-.098-.044-.193-.09-.28-.095-.244-.292-.435-.54-.52l.11-.05c.342-.142.553-.49.52-.86V1.44C9.012.678 8.42.043 7.66 0H5.94c-.507.016-.96.318-1.17.78-.16.386-.21.807-.15 1.22.008.085.035.167.08.24zM23 7.71c-.272-.457-.632-.854-1.06-1.17-.533-.394-1.106-.73-1.71-1-.134-.06-.27-.114-.41-.16-.013-.005-.027-.01-.04-.01-.073-.005-.135.048-.14.12l.24.13c.382.155.75.343 1.1.56.443.25.828.59 1.13 1 .377.526.377 1.234 0 1.76-.295.408-.673.75-1.11 1-.458.283-.948.51-1.46.68-.46.16-.96.34-1.4.47s-.89.2-1.34.3c-.66.14-1.328.243-2 .31l-.69.076c-.08.077-.126.183-.12.294 0 .39-.01.91 0 1.16s.07.3.31.3h.23c.44-.06.78-.1 1.34-.19s1.08-.19 1.56-.29.95-.24 1.41-.39c.525-.172 1.04-.376 1.54-.61.737-.332 1.413-.785 2-1.34.406-.376.7-.857.85-1.39.135-.546.052-1.123-.23-1.61zm-1.61-4.94c.546-.255.88-.82.84-1.42h-.02c-.008-.22-.08-.432-.21-.61-.276-.47-.785-.753-1.33-.74-.703.027-1.298.53-1.44 1.22-.07.406.04.82.3 1.14.453.546 1.22.715 1.86.41zM20.73 1c.252.014.456.21.48.46l-.01.05c.01.267-.193.494-.46.51-.276-.005-.5-.224-.51-.5.014-.274.227-.495.5-.52z"
          />
        </svg>
        Панорама
      </li>
    );
  }

  private renderSimilarTab() {
    return (
      <li
        {...mergeStyles([
          styles['tab'],
          styles['similar'],
          this.props.activeTab === MapTab.similarOffers && styles['active'],
        ])}
        onClick={() => {
          this.handleClickOnTab(MapTab.similarOffers);
          trackTabSimilarClick();
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15">
          {/* tslint:disable-next-line:max-line-length */}
          <path
            fill="currentColor"
            d="M6 0H1C.448 0 0 .448 0 1v5c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V1c0-.552-.448-1-1-1zm-.4 5.6H1.4V1.4h4.2v4.2zM14 0H9c-.552 0-1 .448-1 1v5c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V1c0-.552-.448-1-1-1zm-.4 5.6H9.4V1.4h4.2v4.2zM6 8H1c-.552 0-1 .448-1 1v5c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V9c0-.552-.448-1-1-1zm-.4 5.6H1.4V9.4h4.2v4.2zM14 8H9c-.552 0-1 .448-1 1v5c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V9c0-.552-.448-1-1-1zm-.4 5.6H9.4V9.4h4.2v4.2z"
          />
        </svg>
        Похожие рядом
      </li>
    );
  }

  private handleClickOnTab = (tab: TMapTab) => {
    this.props.changeTab(tab);
  };

  private getSpecialPromoLink = (specialPromoInfo: ISpecialPromoInfo) => {
    const { builderId, jkMapInfo } = specialPromoInfo;
    const newbuildingsMapParams = ['with_newobject=1', 'object_type=2', 'newbuildings_search=true'];

    const params = [
      'deal_type=2',
      `center=${jkMapInfo.lat},${jkMapInfo.lng}`,
      `zoom=${jkMapInfo.zoom}`,
      `builder=${builderId}`,
      'currency=2',
      'engine_version=2',
      ...newbuildingsMapParams,
    ].join('&');

    return `/map/?${params}`;
  };
}
